import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Address  {
    _originalTypeClassName = "zERP.BO.Address";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Address.translate = translateService;
}
this.Id = null;
this.Name = null;
this.StreetName = null;
this.StreetNumber = null;
this.PostalCode = null;
this.City = null;
this.ExtraInfo = null;
this.FullAddress = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
StreetName:any;
StreetNumber:any;
PostalCode:any;
City:any;
ExtraInfo:any;
FullAddress:any;
Country:any;
Region:any;
City_:any;
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
}
}
static setRegion = ($this, value) => {
var oldValue = $this.Region;
$this.Region = value;
if (value != null) {
}
}
static setCity_ = ($this, value) => {
var oldValue = $this.City_;
$this.City_ = value;
if (value != null) {
}
}

static AsString($this: any): any{return $this?.StreetName + " " + $this?.StreetNumber + ", " + $this?.City + " " + $this?.PostalCode;
}
static GetFullAddress($this: any): any{return $this?.StreetName + " " + $this?.StreetNumber + ", " + $this?.PostalCode + ", " + $this?.City;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}